import { COMPANY_ADDRESS_FULL, COMPANY_LOCATION, COMPANY_NAME } from '../constants';
import SectionHeading from './section-heading';
import SignalCard from './signal-card';

function DetailsSection() {
  return (
    <section id="details" className="mx-auto max-w-6xl px-5 py-20">
      <div className="grid gap-8 border border-fd-line bg-fd-paper p-5 shadow-document md:grid-cols-[0.9fr_1.1fr] md:p-8">
        <SectionHeading eyebrow="Details" title="Visible source fields." />
        <dl className="grid gap-4 sm:grid-cols-2">
          <SignalCard label="Company" value={COMPANY_NAME} />
          <SignalCard label="Location" value={COMPANY_LOCATION} dark />
          <div className="sm:col-span-2">
            <SignalCard label="Company Address" value={COMPANY_ADDRESS_FULL} />
          </div>
        </dl>
      </div>
    </section>
  );
}

export default DetailsSection;
